<template>
  <v-card>
    <GenericListTable
      :parentID="this.parentID"
      :title="`Organisations`"
      :headers="[
        { text: 'ID', value: 'id' },
        { text: 'Organisation Name', value: 'companyname' },
        { text: 'Organisation Description', value: 'description' },
      ]"
      :url="`/schemas/organisations`"
      :apiResponseField="`organisations`"
      :onClickRoute="`OrganisationSingle`"
      :onClickParams="getOnClickParams"
    >
    </GenericListTable>
  </v-card>
</template>

<script>
import GenericListTable from '@/components/Common/GenericListTable'
export default {
  name: 'OrganisationListTable',
  components: { GenericListTable },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  methods: {
    getOnClickParams (item) {
      return {
        id: item.id
      }
    }
  }
}
</script>
